export default __webpack_public_path__ + "media/images/cart_icon01-20b9c77a0a57d820679b389e3bb8d9f8.svg";